import { render, staticRenderFns } from "./DepartmentForm.vue?vue&type=template&id=8315234c&"
import script from "./DepartmentForm.vue?vue&type=script&lang=js&"
export * from "./DepartmentForm.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentForm.vue?vue&type=style&index=0&id=8315234c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports